import type { ValueOf } from '@shared/types/Helpers';
import type { ToasterProps } from 'vue-sonner';

const toasterTitle = {
  ACCESS_DENIED: 'ACCESS_DENIED',
  MODIFICATION_NOT_SAVED: 'MODIFICATION_NOT_SAVED',
  UPSERT_SUCCESS: 'UPSERT_SUCCESS',
  UPDATE_SUCCESS: 'UPDATE_SUCCESS',
  GENERATE_TEMPLATE_SUCCESS: 'GENERATE_TEMPLATE_SUCCESS',
  GENERATE_TEMPLATE_ERROR: 'GENERATE_TEMPLATE_ERROR',
} as const;

const typeOfMessage = {
  WARNING: 'warning',
  ALERT: 'alert',
  SUCCESS: 'success',
  DANGER: 'danger',
  INFO: 'info',
} as const;

type Message = {
  title: ValueOf<typeof toasterTitle>;
  content: string;
  type: ValueOf<typeof typeOfMessage>;
  redirect?: {
    to: string;
    label: string;
  };
  props?: ToasterProps;
};

interface ToasterMessage {
  messages: Message[];
}

export type { Message, ToasterMessage };

export { toasterTitle, typeOfMessage };
